import React from 'react';
import Accordion from '../../components/Accordianitem/Accordion';
import BloodPressureForm from './ObjectiveContents/BloodPressure';
import TemperatureForm from './ObjectiveContents/Temperature';
import Spo2Form from './ObjectiveContents/Spo2';
import BloodKetoneForm from './ObjectiveContents/BloodKetone';
import BloodSugarForm from './ObjectiveContents/BloodSugar';
import BloodUricAcidForm from './ObjectiveContents/BloodUricAcid';
import CreatinineForm from './ObjectiveContents/Creatinine';
import GFRForm from './ObjectiveContents/GFR';
import HeartRateForm from './ObjectiveContents/HeartRate';
import HematocritForm from './ObjectiveContents/Hematocrit';
import HemoglobinForm from './ObjectiveContents/Hemoglobin';
import LipidProfileForm from './ObjectiveContents/LipidProfile';
import LFTForm from './ObjectiveContents/LungFunctionTests';
import UreaForm from './ObjectiveContents/Urea';
import UrinalysisForm from './ObjectiveContents/Urinalysis';
import RespirationRateForm from './ObjectiveContents/RespirationRate';
import BMIForm from './ObjectiveContents/BMI';
import { Sparkles } from 'lucide-react';

const staticVitalsData = (id: string) => [
  { title: <span className='font-jost text-lg'>Blood Pressure (BP)</span>, content: <BloodPressureForm  patientId={id}/> },
  { title: <span className='font-jost text-lg'>Temperature</span>, content: <TemperatureForm patientId={id} /> },
  { title: <span className='font-jost text-lg'>SpO2</span>, content: <Spo2Form patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Respiration Rate</span>, content: <RespirationRateForm patientId={id} /> },
  { title: <span className='font-jost text-lg'>Heart Rate</span>, content: <HeartRateForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>BMI</span>, content: <BMIForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Blood Sugar</span>, content: <BloodSugarForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Hemoglobin (Hb)</span>, content: <HemoglobinForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Hematocrit (HCT)</span>, content: <HematocritForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Lung Function Test (LFT)</span>, content: <LFTForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Lipid Profile</span>, content: <LipidProfileForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Urinalysis</span>, content: <UrinalysisForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Blood Uric Acid</span>, content: <BloodUricAcidForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Blood Ketone</span>, content: <BloodKetoneForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Urea</span>, content: <UreaForm patientId={id}  /> },
  { title: <span className='font-jost text-lg'>Creatinine</span>, content: <CreatinineForm patientId={id} /> },
  { title: <span className='font-jost text-lg'>GFR</span>, content: <GFRForm patientId={id} /> },
];

const ObjectiveContent: React.FC<{ id: string }> = ({ id }) => {
  console.log('Patient ID:', id);

  // Pass the `id` to the staticVitalsData function to create the list
  const accordionItems = staticVitalsData(id);

  return (
    <div className="p-4 space-y-6">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default ObjectiveContent;
